<div class="section">
  <div class="section-content">
    <div class="my-24">
      <div class="grid justify-content-center align-items-center relative">
        <img
          style="margin-right: 8px"
          [src]="filter"
          [alt]="filter"
          height="24"
          width="24"
        />
        <div class="typography typography-h4 typography-bold black">Фильтр</div>
        <div
          class="typography typography-h2 typography-medium grey-900 absolute"
          style="cursor: pointer; right: 4px"
          (click)="closeFiltersModal()"
        >
          ✕
        </div>
      </div>
    </div>

    <ng-content></ng-content>

    <div
      class="section bg-white shadow-white-plus full-width left-0 bottom-0"
      style="position: fixed; z-index: 9999"
    >
      <div class="section-content py-20">
        <button
          class="button button-primary full-width"
          (click)="closeFiltersWithScrollTo()"
        >
          Применить
        </button>
      </div>
    </div>
  </div>
</div>
